<template>
    <button :class="[$style.button, $style[`button_theme_${modify}`], {[$style['button_is_disabled']]: disabled}]"
            @click="$emit('click')"
            :type="type || 'button'"
            :disabled="disabled">
        <span :class="$style['button__inner']">
            <slot></slot>
        </span>
    </button>
</template>

<script>
    export default {
        props: ['modify', 'type', 'disabled']
    }
</script>



<style lang="scss" module>
    .button {
        @include reset-button();
        @include scale(border, 1.5, 1.5, 1.5, solid rgba($brand-accent, 0.3));
        @include scale(padding, 5 6, 3.5 5, 5.5 8);
        @include scale(margin, 0 0 24, 0 30 0 0, 0 30 0 0);
        @include font-size(p3);
        position: relative;
        z-index: z(default);
        display: inline-block;
        width: 100%;
        color: $white;
        white-space: nowrap;
        outline: none;
        cursor: pointer;

        &:before,
        &:after {
            @include scale(border, null, 1.5, 1.5, solid transparent);
            width: 0;
            height: 0;

            // Media
            @media #{$laptop} {
                @include pseudo();
            }
        }

        &:before {
            @include scale(top, null, -1.5, -1.5);
            @include scale(left, null, -1.5, -1.5);
            transition: height 0.1s ease-out 0.2s, width 0.1s ease-out 0.3s, border-color 0s ease-out 0.4s;
        }

        &:after {
            @include scale(bottom, null, -1.5, -1.5);
            @include scale(right, null, -1.5, -1.5);
            transition: height 0.1s ease-out, width 0.1s ease-out 0.1s, border-color 0s ease-out 0.2s;
        }

        &:hover {
            &:before,
            &:after {
                @include scale(width, null, func "calc(100% + $)" 3, func "calc(100% + $)" 3);
                @include scale(height, null, func "calc(100% + $)" 3, func "calc(100% + $)" 3);
            }

            &:before {
                // Media
                @media #{$laptop} {
                    border-top-color: rgba($brand-accent, 0.4);
                    border-right-color: rgba($brand-accent, 0.4);
                    transition: width 0.1s ease-out, height 0.1s ease-out 0.1s;
                }
            }

            &:after {
                // Media
                @media #{$laptop} {
                    border-bottom-color: rgba($brand-accent, 0.4);
                    border-left-color: rgba($brand-accent, 0.4);
                    transition: border-color 0s ease-out 0.2s, width 0.1s ease-out 0.2s, height 0.1s ease-out 0.3s;
                }
            }

            .button__inner {
                // Media
                @media #{$laptop} {
                    background-color: $brand-accent;
                }
            }
        }
    }

    .button:disabled,
    .button_is_disabled {
        cursor: default;
        pointer-events: none;

        &:before {
            display: none;
        }

        .button__inner {
            background-color: $brand-accent-lite;
        }
    }

    .button__inner {
        @include transition(background-color);
        @include scale(padding, 5 20, 6.5 12, 7 20);
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $brand-accent-dark;
        position: relative;
    }

    // MODS
    .button_theme_white {
        color: $brand-dark-brown;
        border-color: rgba($white, 0.3);

        span {
            background-color: $white;
        }
    }

    .button_theme_auto {
        width: auto;
    }
</style>
